(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yotpo-reviews-host"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.getElementById('yotpo-reviews-host-{{ section.id }}');
    if (!root) return;

    const initYotpo = () => {
      const container = window.yotpoWidgetsContainer;
      if (container && typeof container.initWidgets === 'function') {
        container.initWidgets();
      }

      const widgets = root.querySelectorAll('.yotpo-reviews-main-widget, .yotpo-widget-override-css');
      widgets.forEach((widget) => {
        widget.style.setProperty('--primary-font-family', 'var(--font-body--family)', 'important');
        widget.style.setProperty('--secondary-font-family', 'var(--font-body--family)', 'important');
      });
    };

    // Re-init once the section is painted to avoid measuring stale widths.
    requestAnimationFrame(() => {
      setTimeout(initYotpo, 0);
    });

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target && event.target.contains(root)) {
        initYotpo();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
